/**
 * This file contains utility functions to be used throughout the code base. New functions should
 * be included here instead of `client/util/index.js`. `client/util/index.js` contains legacy
 * utility functions and imports files that can cause failures if included in `client/signup` for
 * example.
 */

export default {
  addEventListener(event, method) {
    window.addEventListener(event, method);
  },

  /**
   * Searches through the query string and finds the value for the given key, if any
   * @param {String} key - The key of the query parameter to be searched
   * @param {String} [queryString] - The complete query string to be searched
   * @return {String} The value of the query parameter. If none, empty string.
   */
  getQueryStringParameter(key, queryString = window.location.search) {
    const results = new RegExp(`[\\?&]${key}=([^&#]*)`).exec(queryString);
    return results ? decodeURIComponent(results[1]) : '';
  },

  /**
   * Serialize an object to be a query string
   * @param {Object} obj - The object to be serialized
   * @return {String} The serialized string
   */
  serialize(obj) {
    const strArray = [];
    Object.keys(obj).forEach((key) => {
      strArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    });
    return strArray.join('&');
  },

  setLocation(url) {
    window.location = url;
  },

  /**
 * Takes an array of any type and shuffles the items into a random order
 * @see Fisher-Yates Shuffle: https://bost.ocks.org/mike/shuffle/
 * @param {Array}
 * @param {Boolean} last - If true, keep the last item in the array in place
 * @return {Array} New Array with items shuffled
 */
  shuffleArray(array, last = false) {
    let currentIndex = array.length;
    let temporaryValue;
    let randomIndex;
    const shuffled = [...array];
    // while there remain elements to shuffle
    while (currentIndex !== 0) {
    // Pick a remaining element
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element
      temporaryValue = shuffled[currentIndex];
      shuffled[currentIndex] = shuffled[randomIndex];
      shuffled[randomIndex] = temporaryValue;
    }
    if (last) {
      const lastItem = array[array.length - 1];
      shuffled.push(shuffled.splice(shuffled.indexOf(lastItem), 1)[0]);
    }
    return shuffled;
  },
};
